import { urlPrefix } from '@/configs/api'
import axios from '@/api/common/axios'
import { AxiosRequestConfig, AxiosPromise } from 'axios'
import moment from 'moment'
import sysLocalStorage, { enStorageName } from '@/store/localStorage'

const apiUrl = `${urlPrefix}/auth`
//#region 登陆及权限
export const PostLogin = `${apiUrl}/login`
export const GetValidCode = (uuid: string) => `${apiUrl}/validate_code?uuid=${uuid}`
export const PostRefreshToken = `${apiUrl}/rfs_resource`
export const GetPermission = `${urlPrefix}/permission`
//#endregion

export const getValidCode = (uuid: string) => {
  return tryAxios({
    method: 'get',
    url: GetValidCode(uuid)
  })
}
const isStillValid = (exp: any) => {
  return moment() < moment(exp, 'dddd, MMMM Do YYYY, h:mm:ss a')
}

const momentAddMinutes = (minutes: number) => {
  return moment().add(minutes, 'm').format('dddd, MMMM Do YYYY, h:mm:ss a')
}

export interface AuthTokenMap {
  access_token: string
  access_exp: number
  refresh_token: string
  refresh_exp: number
  id: string
  name: string
  roles: string
  attach_access_code?: string
}

export const logout = () => {
  sysLocalStorage.clear()
}
const snToken = 'Token'
const snTokenExp = 'TokenExp'
const snRToken = 'RToken'
const snRTokenExp = 'RTokenExp'
const snUserId = 'UserId'
const snUserName = 'UserName'
const snUserRole = 'UserRole'
const snAttachCode = 'AttachAccessCode'
export const setUserToken = (data: AuthTokenMap) => {
  sysLocalStorage.clear()
  sysLocalStorage.setItem(snToken, data.access_token)
  sysLocalStorage.setItem(snTokenExp, momentAddMinutes(data.access_exp))
  sysLocalStorage.setItem(snRToken, data.refresh_token)
  sysLocalStorage.setItem(snRTokenExp, momentAddMinutes(data.refresh_exp))
  sysLocalStorage.setItem(snUserId, data.id)
  sysLocalStorage.setItem(snUserName, data.name)
  sysLocalStorage.setItem(snUserRole, data.roles)
  sysLocalStorage.setItem(snAttachCode, data.attach_access_code || '')
}

export const getUserToken = () => {
  const token = sysLocalStorage.getItem(snToken)
  const exp = sysLocalStorage.getItem(snTokenExp)
  return { token, valid: isStillValid(exp) }
}
export const getRefreshToken = () => {
  const rtoken = sysLocalStorage.getItem(snRToken)
  const exp = sysLocalStorage.getItem(snRTokenExp)
  return { rtoken, rvalid: isStillValid(exp) }
}

interface IStoredUser {
  getId: () => string
  getName: () => string
  getRoles: () => string
  getAttachAccessCode: () => string
  get: (field: string) => string
}

export const storedUser: IStoredUser = {
  getId: () => {
    return storedUser.get(snUserId)
  },
  getName: () => {
    return storedUser.get(snUserName)
  },
  getRoles: () => {
    return storedUser.get(snUserRole)
  },
  getAttachAccessCode: () => {
    return storedUser.get(snAttachCode)
  },
  get: (field: string) => {
    let result = ''
    if (isLoggedIn()) {
      result = sysLocalStorage.getItem(field)
    }
    return result
  }
}

const refresh = (next: () => any, rtoken: string): Promise<any> => {
  const userId = storedUser.getId()
  const body = { Resource: rtoken, ResourceID: userId }
  return axios.post(PostRefreshToken, body)
    .then((response) => {
      if (response && response.data) {
        setUserToken(response.data)
      }
      return response.data
    }).then((data) => next())
}

const startTry = (next: () => AxiosPromise<any>) => {
  const { token, valid } = getUserToken()
  if (!token || !valid) {
    const { rtoken, rvalid } = getRefreshToken()
    if (rtoken && rvalid) {
      return refresh(next, rtoken)
    }
  }
  return next()
}

export const login = (data: any): AxiosPromise<any> => {
  var _config: AxiosRequestConfig = {
    withCredentials: false
  }
  return axios.post(PostLogin, data, _config)
    .then((res: { data: any }) => {
      var msg = res.data
      if (!msg.IsError) {
        const data = msg.MsgObj//JSON.parse()
        setUserToken(data)
      }
      return msg
    })
}

export const tryAxios = (config: AxiosRequestConfig) => {
  // config.withCredentials = false
  const next = () => axios.request(config)
  return startTry(next)
}

export const isLoggedIn = () => {
  const { rtoken, rvalid } = getRefreshToken()
  return rtoken && rvalid
}

export const isUserTokenValid = () => {
  const { token, valid } = getUserToken()
  return token && valid
}

export const getPermission = (path: string) => {
  return tryAxios({
    method: 'get',
    url: GetPermission,
    params: { path: path ? path : '' }
  })
}
